import { render, staticRenderFns } from "./ModalEmailTemplateSettings.vue?vue&type=template&id=4e2e5558&scoped=true&"
import script from "./ModalEmailTemplateSettings.vue?vue&type=script&lang=js&"
export * from "./ModalEmailTemplateSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e5558",
  null
  
)

export default component.exports